import type { EmailStatus } from '../services/api'

export const emailStatusView: Record<EmailStatus, { label: string; color: string }> = {
  queued: { label: 'Ожидает отправки', color: 'default' },
  insufficient_balance: { label: 'Недостаточно средств', color: 'warning' },
  submitting: { label: 'Передаётся в Mailgun', color: 'processing' },
  accepted: { label: 'Принято Mailgun', color: 'blue' },
  temporary_failed: { label: 'Временная ошибка', color: 'warning' },
  delivered: { label: 'Доставлено', color: 'success' },
  rejected: { label: 'Отклонено Mailgun', color: 'error' },
  permanent_failed: { label: 'Не доставлено', color: 'error' },
  submission_failed: { label: 'Не передано в Mailgun', color: 'error' },
  delivery_unknown: { label: 'Результат не определён', color: 'default' },
}

export const emailStatusOptions = Object.entries(emailStatusView).map(([value, view]) => ({ value, label: view.label }))
